import React from 'react';
import '../style/Kyagu.scss';
// component
import Header from '../components/public/Header';
// React Bootstrap
import { Container, Row, Col, Image, Tab, Nav } from 'react-bootstrap';
// React redux
import { connect } from 'react-redux';
function Kyagu5({ lang }) {
  const k5 =
    'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fk05.png?alt=media&token=5ceba034-eece-48a6-ac17-4473d33e5c8c';
  return (
    <>
      <Header />
      <Container className='kyagu'>
        <div className='kyaguBody pt-4 pr-5 pl-5'>
          <Row className='kyaguContent d-flex align-items-center justify-content-center'>
            <Col className='align-items-center'>
              {/* Header Image */}
              <Image src={k5} rounded fluid />
              {/* Title */}
              {lang === 'CH' ? (
                <h3 className='text-left text-secondary chinese mb-3 '>
                  蔣確修努
                </h3>
              ) : lang === 'TIB' ? (
                <h3 className='text-left text-secondary tibetan_Dutsa mb-3'>
                  བོད་ཡིག་
                </h3>
              ) : (
                <h3 className='text-left text-secondary mb-3'>English</h3>
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              <Tab.Container id='left-tabs' defaultActiveKey='1'>
                <Row>
                  <Col sm={3}>
                    <Nav variant='pills' className='flex-column '>
                      {/* Tap 1 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='1'>
                          {lang === 'CH' ? (
                            <h4>自傳</h4>
                          ) : lang === 'TIB' ? (
                            <h4>རྣམ་ཐར།</h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 2 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='2'>
                          {lang === 'CH' ? (
                            <h4>大手印</h4>
                          ) : lang === 'TIB' ? (
                            <h4>ཕྱག་ཆེན། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 3 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='3'>
                          {lang === 'CH' ? (
                            <h4>那若六法</h4>
                          ) : lang === 'TIB' ? (
                            <h4>ཆོས་དྲུག </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 4 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='4'>
                          {lang === 'CH' ? (
                            <h4>道歌</h4>
                          ) : lang === 'TIB' ? (
                            <h4>རྡོ་རྗེས་མགུར། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 5 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='5'>
                          {lang === 'CH' ? (
                            <h4>教言</h4>
                          ) : lang === 'TIB' ? (
                            <h4>ཞལ་གདམ། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 6 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='6'>
                          {lang === 'CH' ? (
                            <h4>儀軌</h4>
                          ) : lang === 'TIB' ? (
                            <h4>འདོན་ཆ།</h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 7 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='7'>
                          {lang === 'CH' ? (
                            <h4>法相</h4>
                          ) : lang === 'TIB' ? (
                            <h4>འདྲ་འབག </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 8 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='8'>
                          {lang === 'CH' ? (
                            <h4>法帽</h4>
                          ) : lang === 'TIB' ? (
                            <h4>དབུ་ཞྭ། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 9 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='9'>
                          {lang === 'CH' ? (
                            <h4>佛寺</h4>
                          ) : lang === 'TIB' ? (
                            <h4>དགོན་པ།</h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 10 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='10'>
                          {lang === 'CH' ? (
                            <h4>閉關地</h4>
                          ) : lang === 'TIB' ? (
                            <h4>སྒྲུབ་གནས། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 11 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='11'>
                          {lang === 'CH' ? (
                            <h4>加持物</h4>
                          ) : lang === 'TIB' ? (
                            <h4>བྱིན་རླབས། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 12 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='12'>
                          {lang === 'CH' ? (
                            <h4>紀念法會</h4>
                          ) : lang === 'TIB' ? (
                            <h4>འདས་མཆོད། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Col>

                  {/* Content */}
                  <Col sm={7} md={9}>
                    <Tab.Content className='tabContent'>
                      <Tab.Pane eventKey='1' className='tabPane'>
                        {lang === 'CH' ? (
                          <p className='chineseParagraph p-2'>
                            蔣確修努是慮美多傑的侄輩，也是他的弟子。慮美多傑圓寂之後，大家選
                            出蔣確修努作為法座繼承人當使者找到他時告訴他：“您必須離開您隱修的地方回去當國王，在佛法的黃金寶座上，您還是可以繼續進行靈修”。繼任法座之後，蔣確修努受中國皇帝冊封崇高的宗教地位。他用王室的供養在囊謙興建了一座寺院名為倉芒薩寺，倉薩之名由此而來。後來倉薩家族一直是巴榮噶舉教法的傳承持有者，迄今為止已延續至第十三代。
                          </p>
                        ) : lang === 'TIB' ? (
                          <p>
                            <h1>བོད་ཡིག་</h1>
                          </p>
                        ) : (
                          <p>
                            <h1>English</h1>
                          </p>
                        )}
                      </Tab.Pane>
                      <Tab.Pane eventKey='second' className='tabPane'>
                        <p>i am Singapore</p>
                      </Tab.Pane>
                      <Tab.Pane eventKey='third' className='tabPane'>
                        <p>i am tibet</p>
                      </Tab.Pane>
                      <Tab.Pane eventKey='forth' className='tabPane'>
                        <p>i am tibet</p>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    lang: state.lang.lang,
  };
};

export default connect(mapStateToProps)(Kyagu5);
